"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));
var _CalendarToday = _interopRequireDefault(require("@mui/icons-material/CalendarToday"));
var _moment = _interopRequireDefault(require("moment"));
var _theme = require("../theme");
var _TextInput = _interopRequireDefault(require("./TextFields/TextInput"));
var _DateInput = _interopRequireDefault(require("./TextFields/DateInput"));
var _system = require("@mui/system");
var dates = _interopRequireWildcard(require("@simplybenefits/sb-dates"));
var _i18n = _interopRequireDefault(require("../localization/i18n"));
var _tokens = _interopRequireDefault(require("../localization/tokens"));
var localizationMaps = _interopRequireWildcard(require("../localization/maps"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var HoverText = (0, _system.styled)("div")({
  fontSize: 13
});
var HoverBox = (0, _system.styled)("div")({
  display: "flex",
  flexDirection: "row",
  color: _theme.colors.mediumGrey,
  '&:hover': {
    color: _theme.colors.mainTextGrey
  }
});
var DatePicker = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(DatePicker, _Component);
  function DatePicker() {
    var _this;
    (0, _classCallCheck2["default"])(this, DatePicker);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (0, _possibleConstructorReturn2["default"])(_this, (_this = _callSuper(this, DatePicker, [].concat(args)), _this.state = {
      selectedOption: "".concat(_this.props.defaultSelectedValue),
      customDateRange: false,
      anchorEl: null,
      startDate: dates.getPastDate(dates.getLocalDisplay(), 30, "days", "YYYY/MM/DD", _i18n["default"].locale),
      endDate: dates.getLocalDisplay(dates.getLocalDisplay(), "YYYY/MM/DD", _i18n["default"].locale),
      startDateError: false,
      endDateError: false
    }, _this.anchorElement = /*#__PURE__*/_react["default"].createRef(), _this._handleInputChange = /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(type, value) {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.setState((0, _defineProperty2["default"])({}, type, value));
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }(), _this._resetDateRange = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _this._handleSelectionChange(_this.props.defaultSelectedValue);
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })), _this._selectPreMade = function () {
      _this._handleInputChange("customDateRange", false);
      _this._resetDateRange();
    }, _this._setCustomDateRange = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _this.setState({
              customDateRange: !_this.state.customDateRange,
              startDateError: false,
              endDateError: false,
              startDate: dates.getPastDate(dates.getLocalDisplay(), 30, "days", "YYYY/MM/DD", _i18n["default"].locale),
              endDate: dates.getLocalDisplay(dates.getLocalDisplay(), "YYYY/MM/DD", _i18n["default"].locale)
            });
          case 2:
            _this._submitDate();
          case 3:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    })), _this._submitDate = function () {
      var dateRange = {
        startDate: _this.state.startDate,
        endDate: _this.state.endDate,
        error: null
      };
      _this.props.submitDate(dateRange);
    }, _this._handleSelectionChange = /*#__PURE__*/function () {
      var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(value) {
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              // if the value is stored as french, translate it, otherwise just use the english value
              value = localizationMaps.toEnglish('dateRanges', value) || value;
              if (!(value === 'Custom Date Range')) {
                _context4.next = 4;
                break;
              }
              _this._setCustomDateRange();
              return _context4.abrupt("return");
            case 4:
              if (!(value === 'This Year')) {
                _context4.next = 8;
                break;
              }
              _context4.next = 7;
              return _this.setState({
                selectedOption: value,
                "startDate": (0, _moment["default"])().startOf('year'),
                "endDate": (0, _moment["default"])()
              });
            case 7:
              _this._submitDate();
            case 8:
              if (!(value === 'Last 30 days')) {
                _context4.next = 12;
                break;
              }
              _context4.next = 11;
              return _this.setState({
                selectedOption: value,
                "startDate": (0, _moment["default"])().subtract(30, "days"),
                "endDate": (0, _moment["default"])()
              });
            case 11:
              _this._submitDate();
            case 12:
              if (!(value === 'Last 60 days')) {
                _context4.next = 16;
                break;
              }
              _context4.next = 15;
              return _this.setState({
                selectedOption: value,
                "startDate": (0, _moment["default"])().subtract(60, "days"),
                "endDate": (0, _moment["default"])()
              });
            case 15:
              _this._submitDate();
            case 16:
              if (!(value === 'Last 6 months')) {
                _context4.next = 20;
                break;
              }
              _context4.next = 19;
              return _this.setState({
                selectedOption: value,
                "startDate": (0, _moment["default"])().subtract(6, "month"),
                "endDate": (0, _moment["default"])()
              });
            case 19:
              _this._submitDate();
            case 20:
              if (!(value === 'Last 12 months')) {
                _context4.next = 24;
                break;
              }
              _context4.next = 23;
              return _this.setState({
                selectedOption: value,
                "startDate": (0, _moment["default"])().subtract(12, "month"),
                "endDate": (0, _moment["default"])()
              });
            case 23:
              _this._submitDate();
            case 24:
              if (!(value === 'Next 30 days')) {
                _context4.next = 28;
                break;
              }
              _context4.next = 27;
              return _this.setState({
                selectedOption: value,
                "startDate": (0, _moment["default"])(),
                "endDate": (0, _moment["default"])().add(30, "days")
              });
            case 27:
              _this._submitDate();
            case 28:
              if (!(value === 'Next 60 days')) {
                _context4.next = 32;
                break;
              }
              _context4.next = 31;
              return _this.setState({
                selectedOption: value,
                "startDate": (0, _moment["default"])(),
                "endDate": (0, _moment["default"])().add(60, "days")
              });
            case 31:
              _this._submitDate();
            case 32:
              if (!(value === 'Next 6 months')) {
                _context4.next = 36;
                break;
              }
              _context4.next = 35;
              return _this.setState({
                selectedOption: value,
                "startDate": (0, _moment["default"])(),
                "endDate": (0, _moment["default"])().add(6, "month")
              });
            case 35:
              _this._submitDate();
            case 36:
              if (!(value === 'Next 12 months')) {
                _context4.next = 40;
                break;
              }
              _context4.next = 39;
              return _this.setState({
                selectedOption: value,
                "startDate": (0, _moment["default"])(),
                "endDate": (0, _moment["default"])().add(12, "month")
              });
            case 39:
              _this._submitDate();
            case 40:
              if (!(value === 'Today')) {
                _context4.next = 44;
                break;
              }
              _context4.next = 43;
              return _this.setState({
                selectedOption: value,
                "startDate": new Date(Number((0, _moment["default"])().startOf('day'))),
                "endDate": new Date(Number((0, _moment["default"])().endOf('day')))
              });
            case 43:
              _this._submitDate();
            case 44:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return function (_x3) {
        return _ref4.apply(this, arguments);
      };
    }(), _this._clearDateRange = function () {
      _this.setState({
        startDate: "YYYY/MM/DD",
        endDate: "YYYY/MM/DD",
        startDateError: false,
        endDateError: false
      });
      var dateRange = {
        error: true
      };
      _this.props.submitDate(dateRange);
    }, _this._validateInput = /*#__PURE__*/function () {
      var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(type, value, futureDate, noSaveButton) {
        var dateRange, isValidDate, startDateValid, endDateValid;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              dateRange = {
                startDate: _this.state.startDate,
                endDate: _this.state.endDate,
                error: null
              }; // if the date is invalid, an error message will be returned
              isValidDate = dates.validate(value, !futureDate, false, false, _i18n["default"].locale); // some places this component is used do not have a save button, so we have to handle that with additional logic
              if (!noSaveButton) {
                _context5.next = 9;
                break;
              }
              startDateValid = dates.validate(_this.state.startDate, !futureDate, false, false, _i18n["default"].locale);
              endDateValid = dates.validate(_this.state.endDate, !futureDate, false, false, _i18n["default"].locale);
              if (!startDateValid && !endDateValid) {
                _this.props.submitDate(dateRange);
              }
              _context5.next = 8;
              return _this.setState((0, _defineProperty2["default"])({}, type, isValidDate));
            case 8:
              return _context5.abrupt("return");
            case 9:
              if (!isValidDate) {
                _context5.next = 15;
                break;
              }
              _context5.next = 12;
              return _this.setState((0, _defineProperty2["default"])({}, type, isValidDate));
            case 12:
              dateRange.error = isValidDate;
              _this.props.submitDate(dateRange);
              return _context5.abrupt("return");
            case 15:
              _context5.next = 17;
              return _this.setState((0, _defineProperty2["default"])({}, type, false));
            case 17:
              _this.props.submitDate(dateRange);
            case 18:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      return function (_x4, _x5, _x6, _x7) {
        return _ref5.apply(this, arguments);
      };
    }(), (0, _assertThisInitialized2["default"])(_this)));
  }
  (0, _createClass2["default"])(DatePicker, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return this._submitDate();
            case 2:
              _context6.next = 4;
              return this._handleSelectionChange(this.props.defaultSelectedValue);
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }
      return componentDidMount;
    }()
    /**
     * Toggle custom date picker
     * @private
    */
    /**
     * Used in the datepicker to set the parent set to match the current date range
     * @param startDate
     * @param endDate
     */
    /**
     * This will clear the date range
     */
    /**
     * 
     * @param {*} type 
     * @param {*} value 
     * this will get called onblur for the custom date range, will send the date range to the parent component
     */
    // eslint-disable-next-line consistent-return
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        customOptions = _this$props.customOptions,
        customStyle = _this$props.customStyle,
        _this$props$futureDat = _this$props.futureDate,
        futureDate = _this$props$futureDat === void 0 ? false : _this$props$futureDat,
        _this$props$noSaveBut = _this$props.noSaveButton,
        noSaveButton = _this$props$noSaveBut === void 0 ? false : _this$props$noSaveBut;
      var styles = {
        closeModalIcon: {
          cursor: 'pointer',
          display: 'inline',
          fontSize: '16px',
          marginRight: '5px',
          color: _theme.colors.mainTextGrey,
          zIndex: '1000'
        },
        calendarIcon: {
          display: 'inline',
          fontSize: '16px',
          marginLeft: '12px',
          color: _theme.colors.darkBlue,
          zIndex: '9'
        },
        datePicker: _objectSpread({
          marginTop: '0px',
          color: _theme.colors.skyBlue,
          backgroundColor: _theme.colors.surface,
          textTransform: 'capitalize',
          '&:hover': {
            color: _theme.colors.surface
          }
        }, customStyle),
        dateBlock: {
          display: 'flex',
          flexDirection: 'row',
          width: '100%'
        },
        dateField: {
          width: '50%',
          marginTop: '16px',
          marginBottom: '8px'
        },
        inputBlock: {
          display: "flex",
          flexDirection: "column",
          width: "100%",
          justifyContent: "space-evenly"
        }
      };

      // showing custom date picker
      if (this.state.customDateRange) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            display: "flex",
            flexDirection: "row",
            width: "100%",
            justifyContent: "space-evenly",
            marginBottom: 5
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          style: _objectSpread(_objectSpread({}, styles.inputBlock), {}, {
            marginRight: 5
          })
        }, /*#__PURE__*/_react["default"].createElement(_DateInput["default"], {
          label: _i18n["default"].t(_tokens["default"].labels.dates.dateStart),
          value: this.state.startDate,
          variant: "outlined",
          onChange: function onChange(e) {
            return _this2._handleInputChange('startDate', e.target.value);
          },
          onBlur: function onBlur(e) {
            return _this2._validateInput('startDateError', e.target.value, futureDate, noSaveButton);
          },
          error: Boolean(this.state.startDateError),
          helperText: this.state.startDateError,
          fullWidth: true,
          customStyle: {
            marginRight: "5px"
          }
        }), /*#__PURE__*/_react["default"].createElement(HoverBox, {
          onClick: this._clearDateRange
        }, /*#__PURE__*/_react["default"].createElement(_Close["default"], {
          sx: {
            fontSize: 15,
            alignSelf: "center"
          }
        }), /*#__PURE__*/_react["default"].createElement(HoverText, null, _i18n["default"].t(_tokens["default"].labels.dates.clearDates)))), /*#__PURE__*/_react["default"].createElement("div", {
          style: styles.inputBlock
        }, /*#__PURE__*/_react["default"].createElement(_DateInput["default"], {
          label: _i18n["default"].t(_tokens["default"].labels.dates.dateEnd),
          variant: "outlined",
          value: this.state.endDate,
          onChange: function onChange(e) {
            return _this2._handleInputChange('endDate', e.target.value);
          },
          onBlur: function onBlur(e) {
            return _this2._validateInput('endDateError', e.target.value, futureDate, noSaveButton);
          },
          error: Boolean(this.state.endDateError),
          helperText: this.state.endDateError,
          fullWidth: true
        }), /*#__PURE__*/_react["default"].createElement(HoverBox, {
          onClick: this._selectPreMade
        }, /*#__PURE__*/_react["default"].createElement(_CalendarToday["default"], {
          sx: {
            fontSize: 12,
            marginRight: 1,
            alignSelf: "center"
          }
        }), /*#__PURE__*/_react["default"].createElement(HoverText, null, _i18n["default"].t(_tokens["default"].labels.dates.selectDateRange)))));
      }
      var options = customOptions ? (0, _toConsumableArray2["default"])(customOptions) : this.props.futureDate ? ['Next 30 days', 'Next 60 days', 'Next 6 months', 'Next 12 months', 'Custom Date Range'] : ['This Year', 'Last 30 days', 'Last 60 days', 'Last 6 months', 'Last 12 months', 'Custom Date Range'];
      if (this.props.includeToday) {
        options.unshift('Today');
      }
      return /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        id: "DatePicker",
        variant: this.props.variant || "outlined",
        color: "primary",
        "aria-label": "Select Date Range",
        customStyle: styles.datePicker,
        label: _i18n["default"].t(_tokens["default"].labels.claims.dates),
        fullWidth: true,
        select: true,
        selectOptions: options.map(function (item, i) {
          return {
            key: i,
            value: localizationMaps.fromEnglish("dateRanges", item)
          };
        }),
        value: localizationMaps.fromEnglish("dateRanges", this.state.selectedOption),
        onChange: function onChange(e) {
          return _this2._handleSelectionChange(e.target.value);
        }
      });
    }
  }]);
  return DatePicker;
}(_react.Component);
var _default = exports["default"] = DatePicker;